import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilters, VOFilterType } from '../../types';
import { useFilterOptions } from '../../../../list/api';

export const DealStatus = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading } = useFilterOptions(VOFilterType.STATUS);

  const mappedOptions = options.map(({ label, value }) => ({ label, value }));

  return (
    <AutocompleteField
      multiple
      size="small"
      name="STATUS"
      loading={loading}
      control={control}
      disableCloseOnSelect
      options={mappedOptions}
      disabled={!mappedOptions.length}
      textFieldProps={{
        size: 'small',
        label: 'Deal Types',
        variant: 'outlined',
      }}
    />
  );
};
